module.exports = __webpack_public_path__ + "img/input-logo.00ccb8b5.svg";